import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-059bbe0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "listItem" }
const _hoisted_2 = { class: "listItemHeader" }
const _hoisted_3 = { class: "display:flex;flex-direction:column" }
const _hoisted_4 = { class: "purposeName" }
const _hoisted_5 = {
  key: 0,
  style: {"text-align":"left"},
  class: "vendorCount"
}
const _hoisted_6 = { class: "toggleContainer" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_8 = { class: "vendorPurposeOrFeatureLabel" }
const _hoisted_9 = { class: "discloseButtonContainer" }
const _hoisted_10 = {
  key: 0,
  class: "vendorPurposeOrFeatureLabel"
}
const _hoisted_11 = { class: "vendorPurposeOrFeatureText" }
const _hoisted_12 = {
  key: 1,
  class: "vendorPurposeOrFeatureLabel"
}
const _hoisted_13 = { class: "vendorPurposeOrFeatureID" }
const _hoisted_14 = { class: "vendorPurposeOrFeatureText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_toggle_button = _resolveComponent("toggle-button")!
  const _component_ChevronIcon = _resolveComponent("ChevronIcon")!
  const _component_Vue3SlideUpDown = _resolveComponent("Vue3SlideUpDown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.purpose.name), 1),
        (_ctx.vendorCount)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.vendorCount) + " vendors may use this purpose.", 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_toggle_button, {
          onChange: _ctx.changeConsent,
          sync: true,
          value: _ctx.consent,
          style: {"margin-left":"8px"},
          width: 64,
          height: 30,
          speed: 200,
          color: {checked: '#34b76f', unchecked: '#94a7d1'}
        }, null, 8, ["onChange", "value"]),
        _createVNode(_component_ChevronIcon, {
          onClick: _ctx.expandCollapseClick,
          class: _normalizeClass(_ctx.collapseClass)
        }, null, 8, ["onClick", "class"])
      ])
    ]),
    _createVNode(_component_Vue3SlideUpDown, {
      modelValue: _ctx.expanded,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.expanded) = $event)),
      duration: 200,
      class: "listItemDetail"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.introDescription), 1),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.vendorCount)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "cmpButtonLink disclosureButton",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.viewVendorsClick && _ctx.viewVendorsClick(...args)))
              }, "View List of Vendors"))
            : _createCommentVNode("", true),
          (_ctx.purpose?.illustrations?.length)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "cmpButtonLink disclosureButton",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.viewIllustrations && _ctx.viewIllustrations(...args)))
              }, "View Illustrations"))
            : _createCommentVNode("", true)
        ]),
        (_ctx.vendors.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Vendors Using This Purpose:"))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vendors, (v, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: "vendorPurposeOrFeatureDesc"
          }, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(v), 1)
          ]))
        }), 128)),
        (_ctx.illustrations.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Illustrations:"))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.illustrations, (s, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i+1000,
            class: "vendorPurposeOrFeatureDesc"
          }, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(i+1), 1),
            _createElementVNode("div", _hoisted_14, _toDisplayString(s), 1)
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}